import { createApp, setup } from '@shared/setup'

import PartnerWidget from '@shared/modules/PartnerWidget/PartnerWidget.vue'
import { APP } from '@PartnerWidget/constants'
import 'vite/modulepreload-polyfill'

window._appName = APP.PARTNER_WIDGET.name
window._appGroup = APP.PARTNER_WIDGET.group
const element = document.getElementById('partnerWidget')

const props = { ...element.dataset }

try {
  const app = await setup({
    appInstance: createApp(PartnerWidget, props),
    appName: window._appName,
    languageGetter: () => {
      return new URLSearchParams(location.search).get('language')?.toUpperCase()
    },
  })

  app.mount(element)
} catch (e) {
  console.error("Couldn't mount partnerWidget: ", e)
}
